import { useQuery } from '@tanstack/react-query';

import { connectorService } from '@/services/connector-service';
import type { ConnectorFeatureCurrentSequence } from '@/types/core/connector';
import type { UUID } from '@/utils/uuid';

import { connectorQueryKeys } from './query-keys';

export function useGetConnectorFeatureCurrentSequence(
  tenantId?: UUID,
  connectorId?: UUID,
  featureId?: UUID
) {
  return useQuery<ConnectorFeatureCurrentSequence, Error>({
    queryKey: connectorQueryKeys.currentSequence(
      tenantId,
      connectorId,
      featureId
    ),
    queryFn: async () => {
      if (!tenantId) throw new Error('Missing tenant id');
      if (!connectorId) throw new Error('Missing connector id');
      if (!featureId) throw new Error('Missing feature id');
      return connectorService.getConnectorInvocationSequence(
        tenantId,
        connectorId,
        featureId
      );
    },
    enabled: !!tenantId && !!connectorId && !!featureId,
    // Poll every 5 s so the sequence stays current as the backend auto-queues
    // the next run after each completion.
    refetchInterval: 5_000,
  });
}
